import { Injectable } from '@angular/core';
import { AppRoutingKeys, FormActionTypeEnum, QueryParamsMapType } from '@shared';

@Injectable()
export class QueryParamsProvider {
	private queryParams: QueryParamsMapType;

	public get workfileId(): string | null {
		return this.queryParams ? this.queryParams[AppRoutingKeys.queryParamsMap.workfileId] : null;
	}

	public get projectNumber(): string {
		return this.queryParams[AppRoutingKeys.queryParamsMap.projectNumber];
	}

	public get tableMode(): string {
		return this.queryParams[AppRoutingKeys.queryParamsMap.tableMode];
	}

	public get parentTableName(): string {
		return this.queryParams[AppRoutingKeys.queryParamsMap.entityName];
	}

	public get entryId(): string {
		return this.queryParams[AppRoutingKeys.queryParamsMap.entryId];
	}

	public get childTableName(): string {
		return this.queryParams[AppRoutingKeys.queryParamsMap.tableName];
	}

	public get activeTableName(): string {
		return this.childTableName ? this.childTableName : this.parentTableName;
	}

	public get activeTableId(): string {
		return this.childEntryId ? this.childEntryId : this.entryId;
	}

	public get childEntryId(): string {
		return this.queryParams[AppRoutingKeys.queryParamsMap.childEntryId];
	}

	public get connectionId(): string {
		return this.queryParams[AppRoutingKeys.queryParamsMap.connectionId];
	}

	private get editMode(): boolean {
		return !!this.queryParams[AppRoutingKeys.queryParamsMap.editMode];
	}

	private get dupMode(): boolean {
		return !!this.queryParams[AppRoutingKeys.queryParamsMap.dupMode];
	}

	private get newFromMode(): boolean {
		return !!this.queryParams[AppRoutingKeys.queryParamsMap.newFromMode];
	}

	public set queryParamsObject(queryParamObject: QueryParamsMapType) {
		this.queryParams = queryParamObject;
	}

	public formActionType(): FormActionTypeEnum {
		if (this.editMode) {
			return FormActionTypeEnum.edit;
		}
		if (this.dupMode) {
			return FormActionTypeEnum.duplicate;
		}
		if (this.newFromMode) {
			return FormActionTypeEnum.newFrom;
		}
		return FormActionTypeEnum.default;
	}
}
